<template>
  <div>
    <small
      v-for="(event, index) in items"
      :key="event.id"
      class="d-block"
      v-if="show_more || index < 2"
    >
      <span v-if="!!event.location || event.location_name">
        {{ !!event.location ? event.location.name : event.location_name }} @
      </span>
      {{ moment(event.start).format('LL') }},
      {{ moment(event.start).format('LT') }} - 
      <span v-if="!!event.end && moment(event.start).format('YYYY-MM-DD') != moment(event.end).format('YYYY-MM-DD')">
        {{ moment(event.end).format('LL') }},
      </span>
      {{ moment(event.end).format('LT')}}
      <booking-status-badge
        v-if="showStatus && !!event.status"
        v-model="event.status"
      ></booking-status-badge>
      <booking-status-badge
        v-if="showStatus && !!event.tracking_status"
        v-model="event.tracking_status"
      ></booking-status-badge>
      <b-badge
        v-if="!!event.location_disabled_at || !!event.location && !!event.location.disabled_at"
        variant="danger"
      >
        <i class="fa fa-fw fa-exclamation-triangle"></i>
      </b-badge>
    </small>
    <small v-if="items.length > 2" class="d-block">
      <b-button variant="link" size="sm" class="p-0 text-muted" @click="onToggle">
        <span v-if="!show_more">
          {{ moreCountText }}
          <i class="fa fa-fw fa-chevron-right"></i>
        </span>
        <span v-if="show_more">
          <i class="fa fa-fw fa-chevron-left"></i>
          {{ trans('less').toLowerCase() }}
        </span>
      </b-button>
    </small>
  </div>
</template>

<script>
  import BookingStatusBadge from './../booking/BookingStatusBadge'

  export default {
    props: {
      organization: Object,
      events: Array,
      showStatus: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      BookingStatusBadge,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        show_more: false,
      }
    },
    computed: {
      items() {
        return _.reduce(this.events, (items, event) => {
          if (!event.deleted_at) items.push(event)
          return items
        }, [])
      },
      moreCount() {
        return !this.show_more && this.items.length > 2 ? this.events.length - 2 : 0
      },
      moreCountText() {
        if (!this.moreCount) return null
        return `${this.moreCount} ${trans('other' + (this.moreCount > 1 ? 's' : '')).toLowerCase()} (${this.events.length} ${trans('total').toLowerCase()})`
      },
    },
    methods: {
      onToggle() {
        this.show_more = !this.show_more
      },
    },
  }
</script>